<template>
    <div class="answer-text">
        <template v-if="content && content.length">
            <template v-for="(part, idx) in content" :key="idx">
                <strong
                    v-if="part.bold"
                    :class="part.tone ? `tone-${part.tone}` : ''"
                >{{ part.text }}</strong>
                <span
                    v-else
                    :class="part.tone ? `tone-${part.tone}` : ''"
                >{{ part.text }}</span>
            </template>
        </template>
        <template v-else>
            <div
                v-for="(block, idx) in renderedBlocks"
                :key="idx"
                class="answer-block"
                :class="`answer-block--${block.type}`"
            >
                <ChatInlineCitations :text="block.text" :sources="sources" />
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import ChatInlineCitations from './ChatInlineCitations.vue'

const props = defineProps({
    text: { type: String, default: '' },
    content: { type: Array, default: null },
    sources: { type: Array, default: () => [] },
})

const renderedBlocks = computed(() => {
    const normalized = (props.text || '')
        .replace(/\r\n/g, '\n')
        .replace(/([^\n])\n-\s+/g, '$1\n\n- ')
        .trim()
    if (!normalized) return []

    return normalized
        .split(/\n{2,}/)
        .map(block => block.trim())
        .filter(Boolean)
        .map(block => {
            const isList = block.startsWith('- ')
            const text = isList ? block.replace(/^- /gm, '• ') : block
            return {
                type: isList ? 'list' : 'paragraph',
                text,
            }
        })
})
</script>

<style scoped>
.answer-text {
    font-size: 14px;
    line-height: 1.65;
    color: #23282C;
}

.answer-block + .answer-block {
    margin-top: 10px;
}

.answer-block--list {
    white-space: pre-line;
}

.tone-pos {
    color: #0F6E56;
    font-weight: 600;
}

.tone-neg {
    color: #E30613;
    font-weight: 600;
}

strong {
    font-weight: 600;
    color: #23282C;
}
</style>
